import React, { FC } from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import { Redirect, Route, RouteProps } from 'react-router-dom';

import { getRole, getRootForRole, isAuthenticated } from '../../../utils';

const AuthRoute: FC<RouteProps> = ({ children, ...rest }) => {
  const path = getRootForRole(getRole());

  function render() {
    return !isAuthenticated() ? children : <Redirect to={path} />;
  }

  return <Route {...rest} render={render} />;
};

export default AuthRoute;
